import React, { FC, ReactNode } from 'react';

import classNames from 'classnames';

import {
	EvFiltersPanelProvider,
	EvSection,
	EvSpinner,
	IEvFiltersPanelProviderProps,
	TABLE_FILTERS_SR_SUMMARY
} from '@evinced-private/ui-common';

import { WEB_SDK_TESTS_PAGE_FILTERS_SECTION_ID } from 'data-automation-ids/WebSdkDataAutomationIds';
import { PinnedDateRangeFiltersPanelBar } from 'src/common/components/pinned-date-range-filters-panel';

interface FilterSectionCommonProps {
	isFilterOptionsLoading: boolean;
	showTestPath: boolean;
	titleRow: ReactNode;
	layoutClassName?: string;
	providerProps: Omit<IEvFiltersPanelProviderProps, 'children'>;
}

export const FilterSectionCommon: FC<FilterSectionCommonProps> = ({
	isFilterOptionsLoading,
	showTestPath,
	titleRow,
	layoutClassName,
	providerProps
}) => {
	return (
		<EvFiltersPanelProvider {...providerProps}>
			<div className={classNames(layoutClassName)}>
				{titleRow}
				<EvSection
					ariaLabel="WEB SDK All Tests filters"
					ariaDescribedby={TABLE_FILTERS_SR_SUMMARY}
					ariaLive="polite"
					skipLinkId="filters-section"
					className={classNames('dashboard-section', 'web-sdk-tests-filters-section')}
					dataAutomationId={WEB_SDK_TESTS_PAGE_FILTERS_SECTION_ID}
				>
					{isFilterOptionsLoading ? (
						<EvSpinner />
					) : (
						<div className="filters-area">
							<div className="filter-line">
								<PinnedDateRangeFiltersPanelBar
									panelDefinitions={providerProps.filterDefinitions}
									appliedValues={providerProps.initialValues ?? {}}
									onApply={providerProps.onApply}
								/>
							</div>
							<span className="sr-only" aria-live="assertive">
								{showTestPath
									? 'Showing full test paths in test name column'
									: 'Not showing test path in test name column'}
							</span>
						</div>
					)}
				</EvSection>
			</div>
		</EvFiltersPanelProvider>
	);
};
